// extracted by mini-css-extract-plugin
export default {"privacyPolicyAgreement":"AskQuestion_privacyPolicyAgreement__VAPzS","privacyPolicyLink":"AskQuestion_privacyPolicyLink__N++yW"};